import { Component, inject } from '@angular/core';
import { SessionService } from '@core/services/session';

@Component({
  selector: 'app-link-not-published',
  standalone: true,
  templateUrl: './link-not-published.html',
  styleUrl: './link-not-published.scss',
})
export class LinkNotPublished {
  readonly currentYear = new Date().getFullYear();

  private readonly session = inject(SessionService);

  readonly schoolName = this.session.schoolName || 'the school';
}
